module.exports = __webpack_public_path__ + "img/emoji_40.f9ea4131.png";